// shiftSettingsSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IShiftSettings,
  IShiftSettingsInitialState,
} from "./shiftSettingsModal";
import {
  activeInactiveShiftSetting,
  createShiftSetting,
  deleteShiftSetting,
  getAllActiveShiftSettings,
  getAllShiftSettings,
  getShiftSettingByID,
  updateShiftSetting,
} from "./services/shiftSettings.service";

const initialState: IShiftSettingsInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  ShiftSettingsID: null,
  ShiftSettingsList: [],
  ShiftSettingsDetail: {
    ID: null,
    DoctorID: 0,
    ShiftName: "",
    StartTime: "",
    EndTime: "",
    SlotDuration: 0,
    BranchID: 0,
    ApplicableDays: [],
    IsActive: 1,
  },
};
const shiftSettingsSlice = createSlice({
  name: "shiftSettings",
  initialState,
  reducers: {
    clearShiftSettingsDetails: (state) => {
      state.ShiftSettingsDetail = initialState.ShiftSettingsDetail;
    },
    setShiftSettingsID: (state, action) => {
      state.ShiftSettingsID = action.payload;
    },
    clearShiftSettingsID: (state) => {
      state.ShiftSettingsID = initialState.ShiftSettingsID;
    },
  },
  extraReducers: (builder) => {
    // Get All Shift Settings
    builder.addCase(getAllShiftSettings.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllShiftSettings.fulfilled,
      (state, action: PayloadAction<IShiftSettings[]>) => {
        state.loading = false;
        state.ShiftSettingsList = action.payload || [];
      },
    );
    builder.addCase(getAllShiftSettings.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ShiftSettingsList = [];
    });

    // Create Shift Setting
    builder.addCase(createShiftSetting.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createShiftSetting.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createShiftSetting.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Update Shift Setting
    builder.addCase(updateShiftSetting.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateShiftSetting.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateShiftSetting.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Delete Shift Setting
    builder.addCase(deleteShiftSetting.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteShiftSetting.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteShiftSetting.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Get Shift Setting By ID
    builder.addCase(getShiftSettingByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getShiftSettingByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.ShiftSettingsDetail = action.payload;
    });
    builder.addCase(getShiftSettingByID.rejected, (state, action) => {
      state.formLoading = false;
      state.ShiftSettingsDetail = initialState.ShiftSettingsDetail;
      state.error = action.error.message || "Something went wrong";
    });

    // Get All Active Shift Settings
    builder.addCase(getAllActiveShiftSettings.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllActiveShiftSettings.fulfilled, (state, action) => {
      state.loading = false;
      state.ShiftSettingsList = action.payload;
    });
    builder.addCase(getAllActiveShiftSettings.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Active/Inactive Shift Setting
    builder.addCase(activeInactiveShiftSetting.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(activeInactiveShiftSetting.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(activeInactiveShiftSetting.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearShiftSettingsDetails,
  clearShiftSettingsID,
  setShiftSettingsID,
} = shiftSettingsSlice.actions;

export default shiftSettingsSlice.reducer;
